module.exports = __webpack_public_path__ + "img/empty.3714b4d1.svg";